import { Error } from '../../../../ErrorHandling';
import { Link, Resource } from '../../../../Resource/Types';
import { StringOption } from '../../../Options/Types';

export interface GroupParticipantsOptions {
  loginActivities: StringOption[];
  learningCollections: StringOption[];
}

export type GroupParticipantsOptionsResource = Resource<GroupParticipantsOptions>;

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
  links: ReadonlyArray<Link>;
}

interface Ready {
  kind: 'ready';
}

interface Ready {
  kind: 'ready';
  resource: GroupParticipantsOptionsResource;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (links: ReadonlyArray<Link>): Loading => ({
  kind: 'loading',
  links,
});

export const ready = (resource: GroupParticipantsOptionsResource): Ready => ({
  kind: 'ready',
  resource,
});

export type State = Waiting | Loading | Ready | Error;
